(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-multicolumn"] && !Shopify.designMode) return;
  try {
    
(function () {
  function activate(root, id) {
    if (!root || id == null) return;
    root.querySelectorAll('[data-tab]').forEach(function (t) {
      var on = t.getAttribute('data-tab') === String(id);
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    root.querySelectorAll('[data-tab-panel]').forEach(function (p) {
      var on = p.getAttribute('data-tab-panel') === String(id);
      p.classList.toggle('is-active', on);
      if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });
    root.querySelectorAll('[data-pcarousel]').forEach(function (car) {
      if (car._tmcDisableInner) car._tmcDisableInner();
      if (car._tmcArrowSync) window.requestAnimationFrame(car._tmcArrowSync);
    });
  }

  // Select a swatch: mark active and swap the card image to the variant image.
  // If the swatch has no variant image, leave the card image unchanged.
  function selectSwatch(sw) {
    if (!sw || sw.classList.contains('mm-swatch--more')) return;
    var card = sw.closest('.mm-replica-card');
    if (!card) return;

    var group = sw.closest('.mm-replica-card__swatches');
    if (group) {
      group.querySelectorAll('.mm-swatch').forEach(function (s) {
        if (!s.classList.contains('mm-swatch--more')) s.classList.toggle('is-active', s === sw);
      });
    }

    var url = sw.getAttribute('data-variant-image');
    if (!url) return; // no variant image -> leave the image unchanged

    var img = card.querySelector('.mm-replica-card__img--primary');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  function initSection(root) {
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(root, tab.getAttribute('data-tab')); });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var nextTab = tabs[(i + dir + tabs.length) % tabs.length];
        nextTab.focus();
        activate(root, nextTab.getAttribute('data-tab'));
      });
    });

    // Swatch interactions (delegated, bound once per section root)
    if (!root._tmcSwatchBound) {
      root._tmcSwatchBound = true;
      root.addEventListener('click', function (e) {
        var sw = e.target.closest('.mm-swatch');
        if (!sw || sw.classList.contains('mm-swatch--more')) return;
        e.preventDefault();
        e.stopPropagation();
        selectSwatch(sw);
      });
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var sw = e.target.closest('.mm-swatch');
        if (!sw || sw.classList.contains('mm-swatch--more')) return;
        e.preventDefault();
        e.stopPropagation();
        selectSwatch(sw);
      });
    }

    // Carousel chevron arrows (overlay) + match native cards: one image per card.
    root.querySelectorAll('[data-pcarousel]').forEach(function (car) {
      var track = car.querySelector('[data-track]');
      if (!track || car._tmcArrowsBound) return;
      car._tmcArrowsBound = true;
      // Turn off each card's inner image slideshow (native disables it inside carousels).
      function disableInner() {
        car.querySelectorAll('.tmc-card-wrap slideshow-component').forEach(function (ss) {
          if (ss.getAttribute('disabled') !== 'true') ss.setAttribute('disabled', 'true');
        });
      }
      disableInner();
      window.requestAnimationFrame(disableInner);
      setTimeout(disableInner, 300);
      car._tmcDisableInner = disableInner;
      var arrows = car.querySelectorAll('.tmc-arrow');
      arrows.forEach(function (a) {
        a.addEventListener('click', function () {
          var dir = parseInt(a.getAttribute('data-dir'), 10) || 1;
          var wrap = track.querySelector('.tmc-card-wrap');
          var step = wrap ? (wrap.offsetWidth + 16) * 4 : track.clientWidth * 0.9;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var overflow = track.scrollWidth - track.clientWidth > 4;
        arrows.forEach(function (a) {
          var dir = parseInt(a.getAttribute('data-dir'), 10) || 1;
          a.disabled = !overflow || (dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max);
        });
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      car._tmcArrowSync = sync;
      sync();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-type="tabbed-multicol"]').forEach(initSection);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-section-type="tabbed-multicol"]');
    if (!root) return;
    var refEl = e.target.matches('[data-tab-ref]') ? e.target : e.target.querySelector('[data-tab-ref]');
    var ref = refEl && refEl.getAttribute('data-tab-ref');
    if (ref) activate(root, ref);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
